import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { USER_INFO } from 'src/app/shared/api.constants';
import { User } from 'src/app/shared/models/User';
import { Router } from '@angular/router';
import { Permission } from './permissions.types';
import { AuthenticationService } from 'src/app/modules/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  public permissions: string[] = [];

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  public hasPermission(authPermissions: string[]): boolean {
    // Check authentication
    if (!this.authService.isAuthenticated) {
      this.router.createUrlTree(['/login']);
      return false;
    }
    // Check ALL permissions flag
    if (authPermissions.includes(Permission.ALL)) {
      return true;
    }
    // Check latest permissions
    if (
      this.permissions.length > 0 &&
      this.permissions.find((permission) => {
        return authPermissions.includes(this.toUpperCase(permission));
      })
    ) {
      return true;
    }
    return false;
  }
  /**
   * Format any string value to standardized permission string: 'create quote' -> 'CREATE_QUOTE'
   * @param word string
   * @returns string
   */
  private toUpperCase(word: string): string {
    return word.toUpperCase().split(' ').join('_');
  }
  public setPermissions(permissions: string[]) {
    this.permissions = permissions;
  }
  /**
   * @param user
   * @returns Observable
   */
  public initializePermissions(user?: User) {
    if (user && user.permissions && user.permissions.length > 0) {
      // User object already has permissions, no need to fetch from server
      this.permissions = user.permissions.map((permission) => permission.name);
      return Promise.resolve();
    }
    // Fetch permissions from server if not provided
    return new Promise<void>((resolve, reject) => {
      return this.http.get<User>(USER_INFO)
        .pipe(timeout(10000)) // 10 second timeout
        .subscribe(
          (user) => {
            const permissions = user.permissions?.map(
              (permissions) => permissions.name
            );
            this.setPermissions(permissions);
            resolve();
          },
          (error) => {
            console.error('Failed to fetch user permissions:', error);
            reject(error);
          }
        );
    });
  }
}
